import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Stack, CircularProgress } from '@mui/material';
import { CommonBtn } from '../../../components';

const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

interface BillConfimPopupProps {
  open: boolean;
  handleClose: () => void;
  /** onConfirm may be sync or async */
  onConfirm: () => void | Promise<void>;
}

const BillConfimPopup: React.FC<BillConfimPopupProps> = ({ open, handleClose, onConfirm }) => {
  const [submitting, setSubmitting] = React.useState(false);

  const handleConfirmClick = async () => {
    if (submitting) return;            // hard guard
    setSubmitting(true);
    try {
      await Promise.resolve(onConfirm());
    } finally {
      setSubmitting(false);
    }
  };

  // Prevent closing while submitting (backdrop click / Esc)
  const handleModalClose = (_event: unknown, reason?: 'backdropClick' | 'escapeKeyDown') => {
    if (submitting) return;            // ignore close attempts during submit
    handleClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleModalClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      disableEscapeKeyDown={submitting}
    >
      <Box sx={style}>
        <Stack gap={2}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Would you like to Proceed?
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            This will create the bill and close the table/session.
          </Typography>
          <Stack direction="row" gap={1}>
            <CommonBtn
              variant="contained"
              color="error"
              onClick={handleClose}
              disabled={submitting}
            >
              Cancel
            </CommonBtn>
            <CommonBtn
              variant="contained"
              onClick={handleConfirmClick}
              disabled={submitting}
              startIcon={submitting ? <CircularProgress size={16} /> : undefined}
            >
              {submitting ? 'Processing…' : 'Confirm'}
            </CommonBtn>
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
};

export { BillConfimPopup };
